import HeroSection from '../components/sections/HeroSection';
import FeaturedHighlights from '../components/sections/FeaturedHighlights';
import SuccessStories from '../components/sections/SuccessStories';
import StatsCounter from '../components/sections/StatsCounter';

export default function HomePage() {
  return (
    <>
      
      <title>GiveTech totheBlind | Fulfill a Wish for Assistive Technology</title>
<meta name="description" content="Directly sponsor essential assistive technology for the visually impaired. Browse campaigns or wishlist and make a one-off gift to empower someone in need." />

      <HeroSection />
      <FeaturedHighlights />
      <StatsCounter />
      <SuccessStories />
    </>
  );
}